import React from 'react';
import {Nav} from 'react-bootstrap';
function TabNavigation({data}){
  return(
    <React.Fragment>
      <Nav variant="pills" defaultActiveKey="link-0" className="ws_tab_links">
        {
          data.map((element,index) => (
            <Nav.Item key={index}>
              <Nav.Link eventKey={`link-${index}`}
                onClick={ element.onClick }
              >{element.name}</Nav.Link>
            </Nav.Item>
          ))
        }
      </Nav>
      <hr style={{ marginTop: '-2px', border: '1px solid #000' }} />
    </React.Fragment>
  )
}

export {
  TabNavigation
}
